export interface CustomerModel {
  id?: any;
  name?: string;
  email?: string;
  billDestination?: string;
  contractNumber?: string;
  pricingModel?: number;
  customHeading1?: string;
  customHeading2?: string;
  customHeading3?: string;
  customHeading4?: string;
  customHeading5?: string;
  billingActive?: boolean;
  doUsageCollection?: boolean;
  doTonerMonitoring?: boolean;
  doTonerAutoOrder?: boolean;
  doInkMonitoring?: boolean;
  doInkAutoOrder?: boolean;
  doPrintHeadMonitoring?: boolean;
  doPrintHeadAutoOrder?: boolean;
  doMaintenanceMonitoring?: boolean;
  doMaintenanceAutoOrder?: boolean;
  doFastenerMonitoring?: boolean;
  doFastenerAutoOrder?: boolean;
  custAllSapServer?: boolean;
  customerBpId?: string;
  parentCustomerId?: string;
  countryId?: string;
}

export function customerModelFactory(json?: any): CustomerModel {
  json = json || {};

  return {
    id: json.id,
    name: json.name || "",
    email: json.email || "",
    billDestination: json.billDestination || "",
    contractNumber: json.contractNumber || "",
    pricingModel: json.pricingModel || 0,
    customHeading1: json.customHeading1 || "",
    customHeading2: json.customHeading2 || "",
    customHeading3: json.customHeading3 || "",
    customHeading4: json.customHeading4 || "",
    customHeading5: json.customHeading5 || "",
    billingActive: json.billingActive || false,
    doUsageCollection: json.doUsageCollection || false,
    doTonerMonitoring: json.doTonerMonitoring || false,
    doTonerAutoOrder: json.doTonerAutoOrder || false,
    doInkMonitoring: json.doInkMonitoring || false,
    doInkAutoOrder: json.doInkAutoOrder || false,
    doPrintHeadMonitoring: json.doPrintHeadMonitoring || false,
    doPrintHeadAutoOrder: json.doPrintHeadAutoOrder || false,
    doMaintenanceMonitoring: json.doMaintenanceMonitoring || false,
    doMaintenanceAutoOrder: json.doMaintenanceAutoOrder || false,
    doFastenerMonitoring: json.doFastenerMonitoring || false,
    doFastenerAutoOrder: json.doFastenerAutoOrder || false,
    custAllSapServer: json.custAllSapServer || false,
    customerBpId: json.customerBpId || null,
    parentCustomerId: json.parentCustomerId || null,
    countryId: json.countryId || null,
  } as CustomerModel;
}

export interface Ms4CustomerModel {
  customerId: string;
  customerNumber: string;
  customerName: string;
  alternateCustomerName: string;
  bpid: string;
  // ADDRESS INFO
  name1: string;
  name2?: string;
  line1: string;
  line2?: string;
  city: string;
  region: string;
  postalCode: string;
  country: string;
  taxNumber: string;
  taxNumberXL: string;
}

export function ms4CustomerModelFactory(json?: any): Ms4CustomerModel {
  json = json || {};

  return {
    customerId: json.customerId || null,
    customerNumber: json.customerNumber || null,
    alternateCustomerName: json.alternateCustomerName || null,
    customerName: json.customerName || null,
    bpid: json.bpid || null,
    name1: json.name1 || null,
    name2: json.name2 || null,
    line1: json.line1 || null,
    line2: json.line2 || null,
    city: json.city || null,
    region: json.region || null,
    postalCode: json.postalCode || null,
    country: json.country || null,
    taxNumber: json.taxNumber || null,
    taxNumberXL: json.taxNumberXL || null,
  };
}
